import APIConnection from '@/API/APIConnection';
export default {
    save(data){
        return APIConnection.post(`answers`, data);
    }
}